import { styled, keyframes } from '@mui/material/styles';
import List from '@mui/material/List';

const blink = keyframes`
  from {
    opacity: 0.5;
  }
  to {
    opacity: 1;
  }
`;

export const LoadingList = styled(List)(({ loading }) => ({
  '& > div': loading ? {
    filter: 'blur(5px)',
    animation: `${blink} 1s alternate infinite linear`
  } : {}
}));
